<template>
  <div class="main">

    <section>
      <div class="intro">
        <div class="fontSemiBold16 intro__headline">We „lovemathe“</div>
        <div class="fontSemiBold14 intro__headline">Ein Projekt mit Herz und Verstand! Spielend gegen Matheangst.</div>
        <p class="intro__text">Projekte sind ja in der Regel einmalige Vorhaben unter Berücksichtigung von Faktoren wie Zeit, Ressourcen, Budget, Qualität etc. Soweit die Theorie. Bei diesem Projekt kommt eine weitere Komponente dazu: Herzensangelegenheit. Wir können in diesem Projekt direkt mit und für Kinder entwickeln und so vielleicht ein wenig dazu beitragen, dass Kindern die Angst vor Mathe genommen werden kann bzw. die Möglichkeit gegeben ist, Probleme im Fachbereich Mathematik schon im Vorschulalter zu erkennen. Somit leisten auch wir einen sinnvollen Beitrag die Digitalisierung in den Schulalltag zu integrieren und in diesem Bereich voranzutreiben.</p>
      </div>
    </section>

    <section>
      <div class="col col--left">
        <div class="box" :class="{mounted: isMounted}">
          <figure class="box__logo">
            <img
              class="box__image"
              src="../assets/img/eCommerce.svg"
              alt="Shopware-Logo"
              width="100%"
              height="100%"
            >
          </figure>
          <boxHeader
            v-bind:headline="'Wir können auch E-Commerce'"
            v-bind:text="'Shopsysteme für B2C oder B2B'"
          >
          </boxHeader>
          <boxContent
            v-bind:subHeadline="'Shopsysteme für den E-Commerce'"
            v-bind:text="[
              'Der Bereich des E-Commerce oder einfacher gesagt „Verkaufen im Internet“ ist in den letzten Jahren stetig gewachsen und ein Ende dieses Trends ist nicht in Sicht. Für den erfolgreichen Einstieg bzw. den Ausbau eines E-Commerce Business, ist daher die Auswahl des passenden Shopsystems ein entscheidender Faktor. Das Angebot an Shop-Modellen wächst weiter und macht die Entscheidung nicht einfacher.',
              'Ob Sie sich für eine Open Source, On-Premise oder SaaS Lösung entscheiden oder schon entschieden haben, macht für uns keinen Unterschied. Denn wir verstehen uns als kompetente E-Commerce-Shop Agentur die Ihnen bei Ihren kleinen oder auch größeren Problemen unkompliziert zur Seite steht. Unsere Kunden kommen vornehmlich aus der Shopify und Shopware Welt aber auch mit anderen Shopsystemen haben wir beste Erfahrungen gemacht und bisher immer die passende Lösung gefunden. Auch individuellen Anforderungen und Wünschen z.B. an ein bestimmtes Plugin stellen wir uns jederzeit und gern.'
            ]"
            >
          </boxContent>
        </div>
        <div class="box" :class="{mounted: isMounted}">
          <figure class="box__logo">
            <img
              class="box__image"
              src="../assets/img/shopware_logo_blue-RGB_VER.svg"
              alt="Shopware-Logo"
              width="100%"
              height="100%"
              >
          </figure>
          <boxHeader
            v-bind:headline="'Shopware Plugins'"
            v-bind:text="'Mehr Erfolg im E-Commerce'"
          >
          </boxHeader>
          <boxContent
            v-bind:subHeadline="'Shopware Plugins für den E-Commerce'"
            v-bind:text="[
              '„You´ll never work alone“ heißt für uns als Firma flexibel, schnell und unkompliziert auf Kundenwünsche eingehen zu können. Dabei sind Kundenzufriedenheit und Erfolg unserer Auftraggeber die Motivation unserer Arbeit. Vor allem im Bereich E-Commerce ist die Flexibilität und Anpassung bei der Adaption von Trends ausschlaggebend und ein entscheidender Faktor zum Erfolg. Unseren Fokus bei der eigenen Software-Produkt-Entwicklung haben wir bewusst auf Shopware gelegt. Warum? Dann lies kurz die Firmenbeschreibung (Auszug und Quelle: https://www.shopware.com/de/presse/pressematerial/)',
              '„Shopware ist ein führendes E-Commerce-System und wird von einigen der größten europäischen Marken, Einzelhändlern und Herstellern aus der B2C- und B2B-Branche eingesetzt. Als zukunftsweisende Open-Source-Lösung gibt Shopware Nutzern die Freiheit, Wachstumspotentiale schnell und einfach zu entfalten – mit mehr Flexibilität und weniger Komplexität. So vertrauen heute bereits mehr als 100.000 Unternehmen auf eine Lösung von Shopware, zusammen generierten diese im Jahr 2018 einen kumulierten Gesamtumsatz von 5,8 Milliarden Euro.“',
              'Mit unseren entwickelten Shopware Plugins wirst Du Deinem Shopsystem den Feinschliff geben, um noch erfolgreicher am Markt und letztendlich am Kunden agieren zu können. Mit den von uns entwickelten flexiblen Zusatzmodulen kannst Du Deinen Onlineshop exakt nach Deinen Wünschen und Bedürfnissen gestalten und beliebig erweitern. Entspricht ein Plugin nicht 100% Deinen Ansprüchen, dann finden wir eine passende Lösung dafür. In unserem Portfolio stellen wir demnächst zahlreiche Plugins vor, die Dich bei der Arbeit mit Deinem Online-Shop unterstützen werden.'
            ]"
            v-bind:href="'https://store.shopware.com/detail/index/sArticle/519439'"
            v-bind:linkText="'Zu unseren Produkten'">
            >
          </boxContent>
        </div>
        <div class="box" :class="{mounted: isMounted}">
          <figure class="box__logo">
          <svg
            class="box__image"
            alt="Logo-Centrum-Warenhaus"
            width="100%"
            height="100%"
            xmlns="http://www.w3.org/2000/svg" id="Ebene_1" data-name="Ebene 1" viewBox="0 0 301.89 430.28"><title>Logo</title><path d="M65.16,174.14c.46-15.35,13.46-27.36,28.81-27.36h24.89V120.27H93.37a54.79,54.79,0,0,0-54.72,55.57c.46,30,25.52,53.88,55.55,53.88H120V203.21H93.37A28.25,28.25,0,0,1,65.16,174.14Z" fill="#232856"/><path d="M300.51,90.76,151,.86,1.51,90.76V283.28h299Zm-23,169.52h-253V103.76L151,27.7l126.5,76.06Z" fill="#232856"/><polygon points="158.18 228.68 181.72 228.65 197.75 171.71 213.64 228.72 239.22 228.53 268.6 120.51 241.03 120.51 225.86 176.48 209.29 120.51 186.59 120.51 170.88 176.34 155.04 120.51 127.44 120.51 158.18 228.68" fill="#232856"/><polygon points="39.38 415.92 38.18 420.94 36.92 415.92 29.14 388.53 23.78 388.53 15.92 415.92 14.69 420.75 13.6 415.92 6.1 388.53 0.29 388.53 11.96 427.36 17.31 427.36 25.4 400.02 26.3 396.53 27.21 400.02 35.39 427.36 40.75 427.36 52.52 388.53 46.94 388.53 39.38 415.92" fill="#232856"/><path d="M73.79,398.12a18.39,18.39,0,0,0-11.58,3.6,14.16,14.16,0,0,0-3.89,4.79,13.83,13.83,0,0,0-1.49,6.37,23.7,23.7,0,0,0,.54,5.61c.37,1.43.55,2.15.55,2.15l.93,1.57A10.8,10.8,0,0,0,61,424.86a11,11,0,0,0,2.52,1.72,11.43,11.43,0,0,0,2.67.92,12.92,12.92,0,0,0,2.71.28,8.81,8.81,0,0,0,2.7-.42,9.81,9.81,0,0,0,5.1-3.32l.23,3.32h5V398.57l-2.71-.28C78,398.18,76.19,398.12,73.79,398.12Zm2.57,21.68a5.56,5.56,0,0,1-.81,1.14,7.34,7.34,0,0,1-5.75,2.54,6.32,6.32,0,0,1-4.63-1.92q-2.54-2.6-2.54-8,0-5.71,3-8.51a8.64,8.64,0,0,1,3.43-2,12.66,12.66,0,0,1,3.78-.63,28.47,28.47,0,0,1,3.56.22Z" fill="#232856"/><path d="M103.57,398.63a12.5,12.5,0,0,0-6.11,3.93l-.22-4H91.88v28.79h5.58V407.22a7.78,7.78,0,0,1,2.77-2.51,11.24,11.24,0,0,1,2.39-1,11.86,11.86,0,0,1,3.51-.43,13.48,13.48,0,0,1,3.66.44V398.4a11.9,11.9,0,0,0-2.9-.28A10,10,0,0,0,103.57,398.63Z" fill="#232856"/><path d="M126.94,398.12a12.9,12.9,0,0,0-9,3.63,13.68,13.68,0,0,0-4.38,10.63q0,15.42,15.8,15.43a32.42,32.42,0,0,0,7.44-.73v-4.71a23.18,23.18,0,0,1-6.26.86,19.43,19.43,0,0,1-4.73-.42q-6.43-1.76-6.44-9.65h19V411q0-5.76-2.87-9.18A10.6,10.6,0,0,0,126.94,398.12Zm-7.42,10.94a6.35,6.35,0,0,1,1.84-4.6,7,7,0,0,1,5.22-2,5.85,5.85,0,0,1,4.77,2.12,7,7,0,0,1,1.47,4.52Z" fill="#232856"/><path d="M160.1,398.12a15.1,15.1,0,0,0-9.41,3.57l-.39-3.12h-5.16v28.79h5.58V405.74a10.94,10.94,0,0,1,7.4-2.82,7.65,7.65,0,0,1,2.7.45q3.74,1.33,3.74,8.26v15.73h5.58V411.63q0-7.2-2.51-10.44C166,399.15,163.52,398.12,160.1,398.12Z" fill="#232856"/><path d="M194,398.12a15,15,0,0,0-9.34,3.55V385.85h-5.58v41.51h5.58V405.74a10.9,10.9,0,0,1,7.36-2.82,7.66,7.66,0,0,1,2.71.45q3.77,1.33,3.77,8.26v15.73h5.58V411.63q0-7.2-2.51-10.44C200,399.15,197.47,398.12,194,398.12Z" fill="#232856"/><path d="M229.28,398.12a18.34,18.34,0,0,0-11.57,3.6,14.18,14.18,0,0,0-3.9,4.79,13.83,13.83,0,0,0-1.49,6.37,23.12,23.12,0,0,0,.55,5.61l.54,2.15.93,1.57a11.08,11.08,0,0,0,4.66,4.37,11.75,11.75,0,0,0,2.67.92,13,13,0,0,0,2.72.28,8.74,8.74,0,0,0,2.69-.42,9.84,9.84,0,0,0,5.11-3.32l.22,3.32h5V398.57l-2.71-.28C233.5,398.18,231.68,398.12,229.28,398.12Zm2.57,21.68a5.56,5.56,0,0,1-.81,1.14,7.32,7.32,0,0,1-5.75,2.54,6.34,6.34,0,0,1-4.63-1.92q-2.53-2.6-2.53-8,0-5.71,3-8.51a8.64,8.64,0,0,1,3.43-2,12.66,12.66,0,0,1,3.78-.63,28.47,28.47,0,0,1,3.56.22Z" fill="#232856"/><path d="M265.76,420.3A10.07,10.07,0,0,1,259,423c-2.47,0-4.13-.56-5-1.68s-1.48-3.58-1.48-7V398.57H246.9v16q0,7.32,2.29,10.3t7.5,2.93a13.87,13.87,0,0,0,9.13-3.49l.5,3h5V398.57h-5.58Z" fill="#232856"/><path d="M299.42,414.75a25.61,25.61,0,0,0-5.16-3.21l-4.1-2a10.93,10.93,0,0,1-2.5-1.66,2.66,2.66,0,0,1-.79-2,2.37,2.37,0,0,1,1.14-2,6.63,6.63,0,0,1,2.16-.84,19.15,19.15,0,0,1,4.05-.33,34.41,34.41,0,0,1,6.12.64v-4.77a45.77,45.77,0,0,0-6.36-.45q-6.25,0-9.71,2.35a6.56,6.56,0,0,0-3.21,5.63,7.27,7.27,0,0,0,2.21,5.3,21.48,21.48,0,0,0,5.13,3.18l4.07,1.87a9.85,9.85,0,0,1,2.74,1.84,2.44,2.44,0,0,1,.58,1.79q0,3.15-7.47,3.15a32,32,0,0,1-7.37-.86v4.94a51.33,51.33,0,0,0,7.06.5q6.5,0,10.13-2.21c2.3-1.39,3.46-3.23,3.46-5.52A7.13,7.13,0,0,0,299.42,414.75Z" fill="#232856"/><path d="M60.93,353.22a31.37,31.37,0,0,1-7.17.67q-7.48,0-11.47-4.24Q38.6,345.72,38.61,339t3.74-10.32a12.23,12.23,0,0,1,4.71-2.87,21,21,0,0,1,6.93-1,22.13,22.13,0,0,1,6,.61v-5.32a33.2,33.2,0,0,0-5.7-.39,32,32,0,0,0-6.13.5q-8.37,1.69-12.41,7.92a19.57,19.57,0,0,0-3,10.88q0,9.63,5.81,15a17.73,17.73,0,0,0,6.46,3.79,25.8,25.8,0,0,0,8.42,1.29,44.1,44.1,0,0,0,7.44-.5Z" fill="#232856"/><path d="M79.55,329.56a12.86,12.86,0,0,0-9,3.63,13.68,13.68,0,0,0-4.39,10.63q0,15.42,15.8,15.42a33,33,0,0,0,7.44-.72v-4.71a23.18,23.18,0,0,1-6.26.86,19.48,19.48,0,0,1-4.73-.42Q72,352.5,72,344.6H91v-2.18q0-5.75-2.88-9.18A10.63,10.63,0,0,0,79.55,329.56ZM72.13,340.5A6.37,6.37,0,0,1,74,335.89a7,7,0,0,1,5.22-2A5.82,5.82,0,0,1,84,336a7,7,0,0,1,1.48,4.52Z" fill="#232856"/><path d="M117.17,343.06V358.8h5.58V343.06q0-7.19-2.51-10.43-2.4-3.08-7.53-3.07a15.1,15.1,0,0,0-9.41,3.57l-.39-3.12H97.75V358.8h5.58V337.18a10.94,10.94,0,0,1,7.4-2.82,7.65,7.65,0,0,1,2.7.45Q117.17,336.15,117.17,343.06Z" fill="#232856"/><path d="M148,358.74v-4.46a9.32,9.32,0,0,1-3.12.45,8.73,8.73,0,0,1-2.79-.34c-1.92-.69-2.87-2.85-2.87-6.5V334.28h8.92V330H139.2v-7.14H135L133.62,330l-4.13,1.64v2.63h4.13v13.64a12.53,12.53,0,0,0,2.06,7.53c1.71,2.34,4.36,3.52,7.95,3.52h.89l1.76-.06A8.25,8.25,0,0,0,148,358.74Z" fill="#232856"/><path d="M168.23,330.06a12.54,12.54,0,0,0-6.11,3.94l-.23-4h-5.35V358.8h5.58V338.66a7.66,7.66,0,0,1,2.76-2.51,11.56,11.56,0,0,1,2.4-1,11.79,11.79,0,0,1,3.5-.43,13.61,13.61,0,0,1,3.67.44v-5.27a11.52,11.52,0,0,0-2.9-.28A10.21,10.21,0,0,0,168.23,330.06Z" fill="#232856"/><path d="M199.35,351.74a10.15,10.15,0,0,1-6.8,2.71q-3.69,0-5-1.68c-1-1.24-1.48-3.59-1.48-7V330h-5.58v16q0,7.31,2.29,10.3c1.46,1.95,4,2.92,7.5,2.92a13.82,13.82,0,0,0,9.12-3.48l.5,3h5V330h-5.58Z" fill="#232856"/><path d="M252.4,343.51V358.8H258V343.32q0-7.4-2.39-10.61t-7.65-3.15q-5.3,0-10.15,4.41a8.61,8.61,0,0,0-7.87-4.41,13.47,13.47,0,0,0-2.57.25,15.53,15.53,0,0,0-7.14,3.35l-.39-3.15h-5.13V358.8h5.58l0-21.62a10.47,10.47,0,0,1,6.93-2.82c2.45,0,4.14.65,5.09,1.95s1.48,3.67,1.48,7V358.8h5.58V337a10.29,10.29,0,0,1,6.86-2.68,7.38,7.38,0,0,1,2.74.47Q252.39,336.26,252.4,343.51Z" fill="#232856"/></svg>
          </figure>
          <boxHeader
            v-bind:text="'Centrum Warenhaus'">
          </boxHeader>
          <boxContent
            v-bind:subHeadline="'You’ll never walk alone! - Wir sind bei Euch, auch in diesen Zeiten!'"
            v-bind:text="[
              'Allen Einzelhändlern und Gewerbetreibenden sowie allen Hilfe Suchenden bieten wir an, einen Online-Shop im Rahmen von Centrum-Warenhaus aufzubauen - das Ganze schnell, kostenfrei und unbürokratisch!',
               'Auch ohne deinen Laden zu öffnen, kannst du so deine Waren weitervertreiben. Sei es per Lieferung, Abholung und/oder zum Versand, wir helfen Dir dabei!'
            ]"
            v-bind:href="'https://www.centrum-warenhaus.de'"
            v-bind:linkText="'Zum Centrum Warenhaus'">
          </boxContent>
        </div>
        <div class="box" :class="{mounted: isMounted}">
          <boxHeader
            v-bind:counterNumber=24
            v-bind:text="'Enterprise CMS Livegänge 2019'">
          </boxHeader>
          <boxContent
            v-bind:subHeadline="'24 Sites in 17 Ländern und 14 Sprachen'"
            v-bind:text="[
              'Webseiten erstellen und live bringen ist das eine. Es ist manchmal einfach und manchmal herausfordernd. Enterprise CMS Projekte sind niemals einfach und immer herausfordernd.',
              'Auch 2019 haben wir wieder geholfen, Seiten auf Basis von Enterprise Content Management Systemen live zu bringen. Das ist seit über 20 Jahren eine unserer Kernkompetenzen und wir freuen uns sehr, dass immer mehr Auftraggeber begreifen, dass es um viel mehr geht, als einfach nur darum Content zu veröffentlichen. Wir lieben die Herausforderungen die sich aus den immer höher werdenden Anforderungen und Ansprüchen ergeben. Workflows, (semi-) automatische Übersetzungen, responsive Images, Single Sign-On, Performance etc. sind Themen, über die wir schon lange reden. Inzwischen dürfen wir auch immer mehr zeigen, dass wir sie verstanden haben und umsetzen können.'
            ]">
          </boxContent>
        </div>
        <div class="box" :class="{mounted: isMounted}">
          <figure class="box__logo">
            <img
              class="box__image"
              src="../assets/img/thalia-logo.svg"
              alt="Thalia-Logo"
              width="100%"
              height="100%">
          </figure>
          <boxHeader
            v-bind:headline="'Crafter CMS'"
            v-bind:text="'Erfolgreich bei Thalia eingeführt'">
          </boxHeader>
          <boxContent
            v-bind:subHeadline="'Thalia - Crafter CMS erfolgreich eingeführt'"
            v-bind:text="[
                'Als die Jungs und Mädels von Crafter CMS auf uns zugekommen sind und gefragt haben, ob wir ihr Produkt nicht mit in unser Portfolio aufnehmen wollen, waren wir zunächst skeptisch. Noch ein CMS Hersteller der versucht ein Stück vom immer größer werdenden Kuchen abzubekommen?! In den letzten 20 Jahren haben wir da einige kommen und gehen sehen.',
                'Überzeugt hat uns letztlich nicht nur die Technologie (die Idee GIT als Content Repository zu „missbrauchen“ ist schon ziemlich genial), sondern auch der Spirit der Firma. Genauso stellen wir uns Partnerschaft vor.',
                'Das erste gemeinsame Projekt war dann die Einführung bei Thalia. Gleich mit einem eCommerce Projekt zu starten, ist wahrscheinlich nicht unbedingt das was wir empfehlen würden, aber Thalia war dafür genau der richtige Auftraggeber, weil beim größten deutschen Buchhändler die Digitalisierung wesentlich weiter fortgeschritten ist, als bei den meisten anderen Traditionsfirmen.',
                'Dieses Projekt hat uns viel Spaß gemacht. Danke dafür!'
              ]"
            v-bind:href="'/static/pdf/Thalia_de-Case-Study-German-Version.pdf'"
            v-bind:linkText="'Fallstudie Thalia'">
          </boxContent>
        </div>
      </div>

      <div class="col">
        <div class="box" :class="{mounted: isMounted}">
          <figure class="box__logo">
            <img
              class="box__image"
              src="../assets/img/lovemathe.png"
              alt="Thalia-Logo"
              width="100%"
              height="100%">
          </figure>
          <boxHeader
            v-bind:headline="'Ferry-Porsche-Challenge'"
            v-bind:text="'Digitalisierung an Schulen'">
          </boxHeader>
          <boxContent
            v-bind:subHeadline="'Spielend gegen Matheangst'"
            v-bind:text="[
                'Mit unserem aktuellen Projekt wollen wir die Früherkennung von möglichen Rechenschwächen bei Vorschulkindern unterstützen. Unter www.lovemathe.de\n'+
                'kann jedes Kind mit einem spielerischen Test seine mathematischen Fähigkeiten ausprobieren.\n'+
                'Derzeit befinden wir uns noch in der Entwicklungsphase aber wir haben schon eine erste positive Rückmeldung aus der Schule erhalten: siehe Anhang.\n'+
                'So nimmt das „Produkt“ immer mehr Gestalt an und wir sind zuversichtlich mit Beginn des 2. Schulhalbjahres 2022 mit einem Praxistest starten zu können.',
              ]"
            v-bind:href="'/static/pdf/lovemathe_2022.pdf'"
            v-bind:linkText="'Anhang'">
          </boxContent>
        </div>
        <div class="box" :class="{mounted: isMounted}">
          <figure class="box__logo">
            <img
              class="box__image"
              src="../assets/img/kx-partner-badge-bronze-partner-rgb.svg"
              alt="Boye-Logo"
              width="100%"
              height="auto">
          </figure>
          <boxHeader
            v-bind:headline="'Kentico CMS'"
            v-bind:text="'Kentico Xperience Bronze Partner'">
          </boxHeader>
          <boxContent
            v-bind:subHeadline="'Kentico: die Digitale Xperience Plattform'"
            v-bind:text="[
              'Bei Kentico Xperience verschmelzen Content Management, E-Commerce und digitales Marketing zu einer einzigartigen Erlebnisplattform. Kentico basiert auf APS.NET Technologie und verwendet Microsoft SQL-Server als Datenbank. Als Digitale Xperience Plattform (DXP) und Content-Hub unterstützt Kentico beim Aufbau einer einheitlichen, kanal- und geräteübergreifenden User-Experience mit vielen Out-Of-The-Box Funktionalitäten und macht jede Webseite performant und skalierbar.\n'+
              'Mehr als 1.000 Partner weltweit setzen auf Kentico und über 30.000 Webseiten in 120 Ländern laufen auf Kentico Xperience. Mit 4,5 von 5 Sternen mit dem „Gartner Peer Insights Customer´s Choice“ in der Kategorie Web Content Management Software ausgezeichnet.',
              'Weil wir und unsere Kunden mehr als überzeugt von Kentico Xperience sind, haben wir den nächsten Schritt gemacht. eXa Online ist Kentico Bronze Partner. Wir sind Partner seit 2020.'
            ]"
            v-bind:href="'https://xperience.io/services/find-a-partner?country=Germany&page=1&state='"
            v-bind:linkText="'Zu Kentico'"
            >
          </boxContent>
        </div>
        <div class="box" :class="{mounted: isMounted}">
          <figure class="box__logo">
            <img
              class="box__image"
              src="../assets/img/omv-logo.svg"
              alt="OMV-Logo"
              width="100%"
              height="100%">
          </figure>
          <boxHeader
            v-bind:counterNumber=25000
            v-bind:text="'Intranetuser'">
          </boxHeader>
          <boxContent
            v-bind:subHeadline="'OMV - Intranet für ca. 25.000 Mitarbeiter, Internet und Partnernet erfolgreich relauncht'"
            v-bind:text="[
              'In Zeiten der Agilität scheinen ca. 1,5 Jahre für einen Relaunch viel Zeit zu sein.',
              'Wir finden, dass der Schein hier trügt.',
              'Galt es doch mit dem Relaunch zeitgleich in die Cloud umzuziehen, den kompletten bestehenden Content zu migrieren, alle Vorgaben der Datenschutz-Grundverordnung zu berücksichtigen, Intranet, Internet und das interne Tankstellennetz gleichzeitig live zu bringen und damit alle Schnittstellen von Portlets in Microservices zu transformieren, die Anforderungen von OMV in Wien mit denen von Petrom in Bukarest abzugleichen, verschiedenste Dienstleister zu integrieren, den Kommunikations- und Entscheidungsprozessen in einem sehr großen multinationalen Konzern gerecht zu werden usw.',
              'Für uns zumindest ist die Zeit wie im Flug vergangen und dass alle mit dem Ergebnis glücklich sind, macht uns schon ein bisschen stolz. Schließlich findet auch Oracle, dass dieses Projekt ein besonderes war. Sonst hätten sie sich ja wohl kaum die Mühe gemacht, eine Fallstudie zu erstellen.'
            ]"
            v-bind:href="'/static/pdf/Anwenderbericht_OMV.pdf'"
            v-bind:linkText="'Fallstudie OMV'">
          </boxContent>
        </div>
        <div class="box" :class="{mounted: isMounted}">
          <figure class="box__logo">
            <img
              class="box__image"
              src="../assets/img/aarhus-19-logo.png"
              alt="Boye-Logo"
              width="100%"
              height="auto">
          </figure>
          <boxHeader
            v-bind:headline="'Boye Aarhus 19'"
            v-bind:text="'Short List Small Feature Award'">
          </boxHeader>
          <boxContent
            v-bind:subHeadline="'Boye19 - Small Feature Award auf der short list'"
            v-bind:text="[
              'Wenn man mal Finanzbuchhaltern, Verkäufern, Sprechstundenhilfen, Disponenten, Rezeptionisten - kurz Backend Benutzern - über die Schulter schaut und sieht mit welchen Oberflächen und Klickpfaden sie zu kämpfen haben, überkommt einen meistens das Grauen.',
              'Wir finden, dass das nicht so sein muss und versuchen immer durchzusetzen, dass die Arbeitszeit der Redakteure wertgeschätzt wird und wir die Möglichkeit erhalten, Oberflächen zu entwickeln mit denen das Arbeiten Spaß machen kann.',
              'Exemplarisch haben wir das im November 2019 in Aarhus beim Small Feature Award im Rahmen der Boye Konferenz darzustellen versucht.',
              'Obwohl wir nicht so sehr die (Selbst-) Darsteller sind, und wir erst zwei Wochen vorher beschlossen hatten überhaupt teilzunehmen, haben wir es auf die Short List geschafft.',
              'Nicht schlecht, finden wir!'
            ]"
            v-bind:href="'https://www.boye-co.com/blog/2019/11/15/small-feature-award-2019-little-forest-won-a-close-race-with-a-simple-solution-to-huge-problems'"
            v-bind:linkText="'Small Feature Award im Rahmen der Boye Konferenz'"
            v-bind:videoUrl="'https://www.youtube-nocookie.com/embed/qG7TT8-Ebtc'">
          </boxContent>
        </div>
        <div class="box" :class="{mounted: isMounted}">
          <boxHeader
            v-bind:headline="'Über '"
            v-bind:counterNumber=100000
            v-bind:counterUnit="' App Installationen'"
            v-bind:text="'App Ziel mehr als erreicht'">
          </boxHeader>
          <boxContent
            v-bind:subHeadline="'APP - KPI von 30.000 Installationen deutlich übertroffen'"
            v-bind:text="[
              'Ja, wir wissen, dass es responsive Webseiten sowie progressive Webapps gibt und dass man auch deshalb hinterfragen muss, ob es wirklich einer nativen APP bedarf.',
              'Haben wir gemacht und haben uns dann dafür entschieden. Und das völlig zu Recht, wie die nackten Zahlen zeigen.',
              'Das Ziel war es, in den ersten neun Monaten nach Launch 30.000 Downloads zu erreichen, ohne dafür eine große Werbekampagne zu starten. Das hatten wir nach einem Monat in der Tasche. Nach neun Monaten hatten wir dann, nach wie vor ohne Werbeaktivitäten in den sozialen Netzwerken gestartet zu haben, über 60.000 App Installationen auf der Habenseite. Die Anzahl der erfolgten Downloads aus den Apple und Google Play Stores sind sicher eine stolze Zahl. Noch stolzer macht uns allerdings die durchschnittliche Bewertung von über 4,5 von 5 möglichen Sternen bzw. Punkten und die Tatsache, dass über 56.000 Benutzer die Anwendung tatsächlich benutzen und von denen wiederum können über 30.000 per Push Notifikationen im Direktmarketing angesprochen werden.',
              'APP‘s leben offensichtlich länger als so mancher glaubt.'
            ]">
          </boxContent>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import boxHeader from '../components/boxHeader.vue';
import boxContent from '../components/boxContent.vue';

export default {
  name: 'home',
  components: {
    boxHeader, boxContent,
  },
  data() {
    return {
      isMounted: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.isMounted = true;
    }, 250);
  },
};
</script>


<style lang="scss">

  .intro {
    background-color: var(--white);
    position: relative;
    z-index: 1;

    @media #{$mobile} {
      margin: -1.5rem 0 0;
      padding: 3.5rem var(--boxPadding) 0;
    }
    @media #{$min-tablet} {
      width: 100%;
      margin: -3rem 0 0;
      padding: 3.75rem var(--boxPaddingDesk) 0;
    }
  }
  .intro__headline {
    text-align: center;
    margin-bottom: 1.3rem;
  }
  .intro__text {
    @media #{$mobile} {
      text-align: justify;
    }
    @media #{$min-tablet} {
      text-align: center;
      width: 80%;
      margin: 0 auto;
    }
  }

  section {
    max-width: var(--maxWidth);

    @media #{$mobile} {
      padding: 0 var(--sectionPadding);
      margin: 0 auto var(--boxMargin);
    }
    @media #{$min-tablet} {
      display: flex;
      padding: 0 var(--sectionPaddingDesk);
      margin: 0 auto var(--boxMarginDesk);
    }
  }

  .section--header {
    margin-bottom: 0;
    position: relative;
  }

  .col {
    flex: 1;
  }

  .col--left {
    @media #{$tablet} {
      margin-right: var(--boxMarginTab);
    }
    @media #{$desktop} {
      margin-right: var(--boxMarginDesk);
    }
  }

  .box {
    position: relative;
    box-shadow: 0 0 5px 2px rgba(0,0,0,0.5);
    transition: box-shadow 0.3s;

    @media #{$mobile} {
      margin-bottom: var(--boxMargin);
    }
    @media #{$tablet} {
      margin-bottom: var(--boxMarginTab);
    }
    @media #{$desktop} {
      margin-bottom: var(--boxMarginDesk);
    }
  }

  .box:hover {
    box-shadow: 0 0 10px 2px rgba(0,0,0,0.5);
  }
  .box__logo {
    display: block;
    padding: 1.5rem;
    min-height: 5rem;
    text-align: center;
  }

  .box__image {
    width: 200px;
  }
</style>
